export const DOWNLOADABLE_MAX = 30000;

export type NavValue = 'live' | 'treated' | 'not-treated' | 'deleted';

export const LIVE_REVIEWS = 'live';

export const TREATED_REVIEWS = 'treated';

export const NOT_TREATED_REVIEWS = 'not-treated';

export const API_NOT_TREATED_REVIEWS = 'not_treated';

export const TREATED_AUTO_REPLY_REVIEWS = 'treated_auto_reply';

export const PENDING_AUTO_REPLY_REVIEWS = 'pending_auto_reply';

export const DELETED_REVIEWS = 'deleted';

export const REVIEW_STATUSES = [
    LIVE_REVIEWS,
    TREATED_REVIEWS,
    NOT_TREATED_REVIEWS,
    DELETED_REVIEWS,
];
